export default Object.assign(
  {
    baseUrl: '/api'
  },
  window.settings || {}
);
